import {  Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MomentService } from 'src/app/shared/services/moment.service';

@Injectable({ providedIn: 'root' })
export class ReportNavService {
  private momentService = inject(MomentService);
  constructor(private router: Router) {}

  navToProjectLedger(params: any) {
    const queryParams: any = {};
    if (params.accountCodes) queryParams.accountCodes = params.accountCodes;
    if (params.dateFrom) queryParams.dateFrom = this.formateDate(params.dateFrom);
    if (params.dateTo) queryParams.dateTo = this.formateDate(params.dateTo);
    if (params.subProject) queryParams.subProject = params.subProject;
    this.router.navigate(['reporting/report/project/project-ledger'], { queryParams: queryParams });
  }
  navToGeneralLedger(params: any) {
    const queryParams: any = {};
    if (params.accountCodes) queryParams.accountCodes = params.accountCodes;
    if (params.dateFrom) queryParams.dateFrom = this.formateDate(params.dateFrom);
    if (params.dateTo) queryParams.dateTo = this.formateDate(params.dateTo);

    this.router.navigate(['reporting/report/gl/general-ledger'], { queryParams: queryParams });
  }

  navToNotesToAccounts(params: any) {
    const queryParams: any = {};
    if (params.accountCodes) queryParams.accountCodes = params.accountCodes;
    if (params.dateFrom) queryParams.dateFrom = this.formateDate(params.dateFrom);
    if (params.dateTo) queryParams.dateTo = this.formateDate(params.dateTo);

    this.router.navigate(['reporting/report/gl/nta'], { queryParams: queryParams });
  }

  navToProjectNotesToAccounts(params: any) {
    const queryParams: any = {};
    if (params.accountCodes) queryParams.accountCodes = params.accountCodes;
    if (params.dateFrom) queryParams.dateFrom = this.formateDate(params.dateFrom);
    if (params.dateTo) queryParams.dateTo = this.formateDate(params.dateTo);

    this.router.navigate(['reporting/report/project/project-nta'], { queryParams: queryParams });
  }


  navToSupplierLedger(params: any) {
    const queryParams: any = {};
    if (params.accountCodes) queryParams.accountCodes = params.accountCodes;
    if (params.dateFrom) queryParams.dateFrom = this.formateDate(params.dateFrom);
    if (params.dateTo) queryParams.dateTo = this.formateDate(params.dateTo);

    this.router.navigate(['reporting/report/ap/ap-ledger'], { queryParams: queryParams });
  }

  navToCustomerLedger(params: any) {
    const queryParams: any = {};
    if (params.accountCodes) queryParams.accountCodes = params.accountCodes;
    if (params.dateFrom) queryParams.dateFrom = this.formateDate(params.dateFrom);
    if (params.dateTo) queryParams.dateTo = this.formateDate(params.dateTo);

    this.router.navigate(['reporting/report/ar/ar-ledger'], { queryParams: queryParams });
  }

  navToPnL(params: any) {
    const queryParams: any = {};
    if (params.dateFrom) queryParams.dateFrom = this.formateDate(params.dateFrom);
    if (params.dateTo) queryParams.dateTo = this.formateDate(params.dateTo);
    queryParams.showLevel = 1;
    queryParams.isZoomIn = true;

    this.router.navigate(['reporting/report/gl/pnl-details'], { queryParams: queryParams });
  }

  navToMonthlyBudget(params:any){
    const queryParams: any = {};
    if (params.date) queryParams.date = this.formateDate(params.date);

    this.router.navigate(['gl/budget'], { queryParams: queryParams });
  }

  private formateDate(date: any) {
    return this.momentService.moment(date).format('YYYY-MM-DD');
  }
}
